

export function stickyProductNavInit() {
    const staticProductNavAnchor = document.querySelector('.nav-product-content-wrapper');
    /**
     * sticky product nav
     */
    const productMenuObserver = new window.IntersectionObserver((entries) => {
        const stickyProductNav = document.querySelector('.product-fixed');
        const productFixedVisibilityClass = 'product-fixed--visible';
        let entry = entries[0];

        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            stickyProductNav?.classList.add(productFixedVisibilityClass);
        } else {
            stickyProductNav?.classList.remove(productFixedVisibilityClass);
        }
    });

    staticProductNavAnchor && productMenuObserver.observe(staticProductNavAnchor);
}